import { render, staticRenderFns } from "./transter.vue?vue&type=template&id=36b57aae&scoped=true&"
import script from "./transter.vue?vue&type=script&lang=js&"
export * from "./transter.vue?vue&type=script&lang=js&"
import style0 from "./transter.vue?vue&type=style&index=0&id=36b57aae&prod&lang=css&"
import style1 from "./transter.vue?vue&type=style&index=1&id=36b57aae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b57aae",
  null
  
)

export default component.exports